import React, { useState, useRef } from 'react';
import SVGWhatsappIcon from '../../assets/images/svgs/whatsapp_2.svg?react';
import SVGRightIcon from '../../assets/images/svgs/right_white.svg?react';
import WP_Support from '../../assets/images/wp_support.webp?react';
import { CONFIG } from '../../config/api.config';
import { useSelector } from 'react-redux';

const WhatsappPortal = () => {
  const promotions = useSelector(state => state.promotions.socials);
  const [isVisible, setIsVisible] = useState(false);
  const [animate, setAnimate] = useState('scaleHorizontally');
  const timerRef = useRef(null);

  const handleMouseEnter = () => {
    if (timerRef.current) {
      clearTimeout(timerRef.current);
    }
    setAnimate('scaleHorizontally')
    setIsVisible(true);
  };

  const handleMouseLeave = () => {
    timerRef.current = setTimeout(() => {
      setAnimate('scaleHorizontallyClose');
      handleClose();
    }, 3000);
  };

  const handleClose = () => {
    setTimeout(() => {
      setIsVisible(false);
    }, 350);
  }

  
 if(!promotions || !promotions?.Whatsapp) {
  return null;
 }

  return (
    <div
      title="WhatsAppContact"
      className={`fixed cursor-pointer top-[calc(100dvh-64px)] left-3 z-50 flex w-max h-max items-center justify-center rounded-full ${isVisible? 'bg-bg_Success2 shadow-[rgba(0,_0,_0,_0.24)_0px_3px_8px]' : ''}  transition-all duration-500`}
      onMouseEnter={handleMouseEnter}
      onMouseLeave={handleMouseLeave}
      onClick={() => {window.open(promotions.Whatsapp.url)}}
    >
      <div className="h-full bg-transparent mt-[-3px] ml-[-3px]">
        <img src={WP_Support} alt="WP_Support" width={60} />
      </div>
      
      {(isVisible)&&
        <div className={`${animate} origin-left flex items-center h-full justify-between w-[190px] transition-all duration-500`}>
          <span className="text-xs text-text_Quaternary w-[90%] font-semibold">
            Play And Win. Get a new Id instantly over WhatsApp.
          </span>
          <span>
            <SVGRightIcon  />
          </span>
        </div>
      }

      
    </div>
  )
}

export default WhatsappPortal
